import { apiRequest } from "@/lib/api";

export type ChangePasswordPayload = {
  current_password: string;
  new_password: string;
  new_password_confirm: string;
};

export type ChangePasswordResponse = {
  detail: string;
};

export async function changePassword(
  payload: ChangePasswordPayload,
): Promise<ChangePasswordResponse> {
  return apiRequest<ChangePasswordResponse>(
    "/auth/change-password/",
    {
      method: "POST",
      authenticated: true,
      body: JSON.stringify(payload),
    },
  );
}

export type PasswordResetRequestPayload = {
  email: string;
};

export type PasswordResetRequestResponse = {
  detail: string;
};

export type PasswordResetConfirmPayload = {
  token: string;
  new_password: string;
  new_password_confirm: string;
};

export type PasswordResetConfirmResponse = {
  detail: string;
};

export async function requestPasswordReset(
  payload: PasswordResetRequestPayload,
): Promise<PasswordResetRequestResponse> {
  return apiRequest<PasswordResetRequestResponse>(
    "/auth/password-reset/",
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
}

export async function confirmPasswordReset(
  payload: PasswordResetConfirmPayload,
): Promise<PasswordResetConfirmResponse> {
  return apiRequest<PasswordResetConfirmResponse>(
    "/auth/password-reset/confirm/",
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
}
